<div class="flex flex-col gap-6">
  <!-- 1. Réception du digest quotidien -->
  <div
    class="p-5 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs space-y-3"
  >
    <div class="flex items-center justify-between gap-4">
      <div class="flex items-start gap-3 min-w-0">
        <div
          class="w-10 h-10 rounded-xl flex items-center justify-center shrink-0 mt-0.5"
          [class.bg-primary-2]="internalSettings().emailAlertsEnabled"
          [class.text-primary-11]="internalSettings().emailAlertsEnabled"
          [class.bg-neutral-2]="!internalSettings().emailAlertsEnabled"
          [class.dark:bg-neutral-3]="!internalSettings().emailAlertsEnabled"
          [class.text-neutral-10]="!internalSettings().emailAlertsEnabled"
        >
          <mat-icon class="!w-5 !h-5 !text-xl">mail</mat-icon>
        </div>
        <div class="flex flex-col min-w-0">
          <div class="flex items-center gap-2">
            <span class="text-sm font-bold text-neutral-12">Alertes email quotidiennes (8h00)</span>
            <span
              class="text-[10px] font-bold px-2 py-0.5 rounded-full bg-primary-2 text-primary-11 border border-primary-4"
            >
              Email uniquement
            </span>
          </div>
          <p class="text-xs text-neutral-10 leading-relaxed mt-0.5">
            Recevez un récapitulatif chaque matin à 8h avec les nouveaux mandats publiés par les vendeurs
            correspondant à vos critères et communes.
          </p>
        </div>
      </div>
      <mat-slide-toggle
        [checked]="internalSettings().emailAlertsEnabled"
        (change)="toggleEmailAlerts($event.checked)"
        color="primary"
      ></mat-slide-toggle>
    </div>
  </div>

  <!-- 2. Filtres de pertinence des mandats -->
  @if (internalSettings().emailAlertsEnabled) {
    <div
      class="p-5 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs space-y-4 animate-in fade-in duration-200"
    >
      <div class="flex items-center gap-2.5 pb-3 border-b border-neutral-3 dark:border-neutral-4">
        <mat-icon class="text-primary-9 !w-5 !h-5 !text-xl">filter_list</mat-icon>
        <div class="flex flex-col">
          <span class="text-xs font-bold text-neutral-12 uppercase tracking-wider">
            Filtres de pertinence des mandats
          </span>
          <span class="text-[11px] text-neutral-10">
            Seuls les biens respectant ces conditions vous seront notifiés à 8h.
          </span>
        </div>
      </div>

      <!-- Types de mandats acceptés -->
      <div class="space-y-2">
        <span class="text-xs font-bold text-neutral-11 block">Types de mandats souhaités :</span>
        <div class="flex flex-wrap gap-2.5">
          @for (opt of mandateOptions; track opt.key) {
            @let selected = isMandateSelected(opt.key);
            <button
              type="button"
              class="inline-flex items-center gap-2 px-3.5 py-2 rounded-xl text-xs font-semibold border transition-all cursor-pointer"
              [class.bg-primary-9]="selected"
              [class.text-white]="selected"
              [class.border-primary-9]="selected"
              [class.shadow-xs]="selected"
              [class.bg-neutral-1]="!selected"
              [class.text-neutral-12]="!selected"
              [class.border-neutral-3]="!selected"
              [class.hover:border-neutral-5]="!selected"
              (click)="toggleMandateType(opt.key)"
            >
              <mat-icon
                class="!w-4 !h-4 !text-base"
                [class.!text-white]="selected"
                [class.text-neutral-8]="!selected"
              >
                {{ selected ? 'check_box' : 'check_box_outline_blank' }}
              </mat-icon>
              <span>{{ opt.label }}</span>
            </button>
          }
        </div>
      </div>

      <!-- Fourchette de prix / estimation -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
        <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
          <mat-label>Prix minimum du bien (€)</mat-label>
          <input
            matInput
            type="number"
            aria-label="Prix minimum du bien"
            placeholder="Ex : 150000"
            [value]="internalSettings().minPrice || ''"
            (input)="onPriceChange('minPrice', $any($event.target).value)"
            min="0"
            step="10000"
          />
          <span matSuffix class="text-xs text-neutral-9 font-bold mr-2">€</span>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
          <mat-label>Prix maximum du bien (€)</mat-label>
          <input
            matInput
            type="number"
            aria-label="Prix maximum du bien"
            placeholder="Ex : 1500000 (optionnel)"
            [value]="internalSettings().maxPrice || ''"
            (input)="onPriceChange('maxPrice', $any($event.target).value)"
            min="0"
            step="10000"
          />
          <span matSuffix class="text-xs text-neutral-9 font-bold mr-2">€</span>
        </mat-form-field>
      </div>
    </div>
  }

  <!-- 3. Alerte de solde de crédits bas -->
  <div
    class="p-5 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs space-y-3"
  >
    <div class="flex items-center justify-between gap-4">
      <div class="flex items-start gap-3 min-w-0">
        <div
          class="w-10 h-10 rounded-xl flex items-center justify-center shrink-0 mt-0.5"
          [class.bg-amber-2]="internalSettings().creditLowAlertEnabled"
          [class.text-amber-11]="internalSettings().creditLowAlertEnabled"
          [class.bg-neutral-2]="!internalSettings().creditLowAlertEnabled"
          [class.dark:bg-neutral-3]="!internalSettings().creditLowAlertEnabled"
          [class.text-neutral-10]="!internalSettings().creditLowAlertEnabled"
        >
          <mat-icon class="!w-5 !h-5 !text-xl">token</mat-icon>
        </div>
        <div class="flex flex-col min-w-0">
          <span class="text-sm font-bold text-neutral-12">Alerte de solde de crédits de positionnement</span>
          <p class="text-xs text-neutral-10 leading-relaxed mt-0.5">
            Vous alerte par email lorsque votre stock de crédits de candidature devient faible pour ne manquer
            aucune opportunité.
          </p>
        </div>
      </div>
      <mat-slide-toggle
        [checked]="internalSettings().creditLowAlertEnabled"
        (change)="toggleCreditAlert($event.checked)"
        color="primary"
      ></mat-slide-toggle>
    </div>

    @if (internalSettings().creditLowAlertEnabled) {
      <div class="pt-3 border-t border-neutral-3 dark:border-neutral-4 flex items-center gap-3">
        <span class="text-xs font-semibold text-neutral-11">Alerter lorsqu'il me reste moins de :</span>
        <mat-form-field appearance="outline" class="w-28" subscriptSizing="dynamic">
          <input
            matInput
            type="number"
            aria-label="Seuil de crédits restant"
            [value]="internalSettings().creditThreshold || 2"
            (input)="onCreditThresholdChange($any($event.target).value)"
            min="1"
            max="20"
          />
          <span matSuffix class="text-xs text-neutral-9 font-medium mr-2">crédits</span>
        </mat-form-field>
      </div>
    }
  </div>
</div>
